import { Trans, useTranslation } from "react-i18next";
import { FiArrowUpRight } from "react-icons/fi";
import {
  BrowsePackageTourIcon,
  DesignBespokeTourIcon,
  RequestLuxuryJourneyIcon,
} from "../../../../components/icons";
import { cn } from "../../../../utils/classnames";
import { createTypographyHelper } from "../../../../utils/typography";

const PrivateTourImage = 'https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/services/private-tour-card.png';
const PrivateTourCustomizedImage = 'https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/services/private-tour-customized-tour.png';
const PrivateTourDesignImage = 'https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/services/private-tour-design.png';
const PrivateTourRequestImage = 'https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/services/private-tour-request.png';
const PrivateTourBrowseImage = 'https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/services/private-tour-browse.png';

export const PrivateTour = () => {
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);
  return (
    <div className="tw:lg:px-[82px]">
      <div className="tw:px-5 tw:lg:px-0 tw:mt-7 tw:lg:mt-[54px]">
        <div className="tw:flex tw:flex-col tw:lg:flex-row tw:rounded-[10px] tw:overflow-hidden">
          <img
            src={PrivateTourImage}
            alt="Airport Transfer Card"
            className="tw:w-full tw:h-[300px] tw:lg:h-[260px] tw:lg:min-w-[452px] tw:object-cover tw:rounded-t-[10px] tw:lg:rounded-none tw:flex-1"
          />
          <div className="tw:bg-[#F9F9F9]">
            <div className="tw:px-[25px] tw:lg:px-[48px] tw:pt-8 tw:lg:pt-[46px] tw:pb-7 tw:lg:pb-[46px] tw:space-y-[10px]">
              <div className="tw:pb-4 tw:border-b tw:border-b-[#F1F1F1] tw:mb-4">
                <div className="tw:font-semibold tw:text-[#282828] tw:tracking-[3px] tw:text-[8px] tw:font-hanken-grotesk tw:uppercase">
                  {t(`Service.PrivateTour.Title`)}
                </div>
                <div className="tw:text-[#282828] tw:font-libre-caslon-display tw:text-[26px] tw:lg:text-[45px] tw:leading-[35px] tw:lg:leading-[58px]">
                  {t(`Service.PrivateTour.Title`)}
                </div>
              </div>
              <div
                className={cn(
                  "tw:text-[#4E4E4E] tw:font-hanken-grotesk",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t(`Service.PrivateTour.Description`)}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tw:mt-8 tw:lg:mt-[54px] tw:px-5 tw:lg:px-0 tw:font-libre-caslon-display tw:leading-[23px] tw:lg:leading-[26px] tw:lg:text-[22px] tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1]">
        <div>{t(`Service.PrivateTour.Quote`)}</div>
      </div>

      <div className="tw:px-5 tw:lg:px-0 tw:mt-8 tw:lg:mt-[54px] tw:font-hanken-grotesk tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1] tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row tw:lg:gap-x-[69px]">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[200px] tw:lg:w-[200px]">
          {t("Service.PrivateTour.CustomizedTours.Title")}
        </div>
        <div className="tw:flex tw:flex-col tw:lg:flex-row tw:gap-5 tw:lg:gap-[45px]">
          <div
            className={cn(
              "tw:mt-5 tw:lg:mt-0",
              getTypographyClass(13),
              getTypographyClass(14, "lg")
            )}
          >
            <Trans
              i18nKey="Service.PrivateTour.CustomizedTours.Description"
              components={{
                strong: <strong></strong>,
              }}
            />
          </div>
          <img
            src={PrivateTourCustomizedImage}
            alt="Seamless Event & Meeting Transportation"
            className="tw:h-[220px] tw:lg:h-[230px] tw:lg:min-w-[450px] tw:rounded-[5px]"
          />
        </div>
      </div>

      <div className="tw:px-5 tw:lg:px-0 tw:mt-8 tw:lg:mt-[54px] tw:font-hanken-grotesk tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1] tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row tw:lg:gap-x-[69px]">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[200px] tw:lg:w-[200px]">
          {t("Service.PrivateTour.LuxuriousWorryFreeTravel.Title")}
        </div>
        <div>
          <div
            className={cn(
              "tw:mt-5 tw:lg:mt-0",
              getTypographyClass(13),
              getTypographyClass(14, "lg")
            )}
          >
            <Trans
              i18nKey="Service.PrivateTour.LuxuriousWorryFreeTravel.Description"
              components={{
                strong: <strong></strong>,
              }}
            />
          </div>
          <div className="tw:grid tw:grid-cols-1 tw:lg:grid-cols-3 tw:gap-3 tw:mt-5 tw:lg:mt-8">
            <a className="tw:border tw:border-[#D9D9D9] tw:rounded-[5px] tw:overflow-hidden tw:cursor-pointer tw:group tw:hover:bg-[#121416] tw:!no-underline" href="https://www.japanprivatetour.com/design-a-bespoke-tour">
              <img
                className="tw:h-[160px] tw:w-full tw:object-cover tw:object-center"
                src={PrivateTourDesignImage}
                alt="DESIGN A BESPOKE TOUR"
              />
              <div
                className={cn(
                  "tw:text-[#282828] tw:group-hover:text-white tw:font-bold tw:py-6 tw:px-5 tw:flex tw:justify-between",
                  getTypographyClass(13)
                )}
              >
                <div className="tw:flex tw:items-center tw:gap-2">
                  <DesignBespokeTourIcon className="tw:fill-[#282828] tw:group-hover:fill-white" />
                  {t(
                    "Service.PrivateTour.LuxuriousWorryFreeTravel.DesignBespokeTour"
                  )}
                </div>
                <FiArrowUpRight color="#C9C9C9" size={20} />
              </div>
            </a>
            <a className="tw:border tw:border-[#D9D9D9] tw:rounded-[5px] tw:overflow-hidden tw:cursor-pointer tw:group tw:hover:bg-[#121416] tw:!no-underline" href="https://www.japanprivatetour.com/luxury-experiences">
              <img
                className="tw:h-[160px] tw:w-full tw:object-cover tw:object-center"
                src={PrivateTourRequestImage}
                alt="REQUEST A LUXURY JOURNEY"
              />
              <div
                className={cn(
                  "tw:text-[#282828] tw:group-hover:text-white tw:font-bold tw:py-6 tw:px-5 tw:flex tw:justify-between",
                  getTypographyClass(13)
                )}
              >
                <div className="tw:flex tw:items-center tw:gap-2">
                  <RequestLuxuryJourneyIcon className="tw:fill-[#282828] tw:group-hover:fill-white" />
                  {t(
                    "Service.PrivateTour.LuxuriousWorryFreeTravel.RequestLuxuryJourney"
                  )}
                </div>
                <FiArrowUpRight color="#C9C9C9" size={20} />
              </div>
            </a>
            <a className="tw:border tw:border-[#D9D9D9] tw:rounded-[5px] tw:overflow-hidden tw:cursor-pointer tw:group tw:hover:bg-[#121416] tw:!no-underline" href="https://www.japanprivatetour.com/package-tours">
              <img
                className="tw:h-[160px] tw:w-full tw:object-cover tw:object-center"
                src={PrivateTourBrowseImage}
                alt="BROWSE PACKAGE TOURS"
              />
              <div
                className={cn(
                  "tw:text-[#282828] tw:group-hover:text-white tw:font-bold tw:py-6 tw:px-5 tw:flex tw:justify-between",
                  getTypographyClass(13)
                )}
              >
                <div className="tw:flex tw:items-center tw:gap-2">
                  <BrowsePackageTourIcon className="tw:fill-[#282828] tw:group-hover:fill-white" />
                  {t(
                    "Service.PrivateTour.LuxuriousWorryFreeTravel.BrowsePackageTour"
                  )}
                </div>
                <FiArrowUpRight color="#C9C9C9" size={20} />
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
